/**
 * Filmssavn Admin - Main Application Entry Point
 * Content Management for Faroese Originals
 */

import '../src/styles/admin-system.css';
import { initI18n } from './lib/i18n.js';
import { isAuthenticated } from './lib/keycloak.js';
import { router } from './lib/router.js';
import { renderCallback } from './pages/callback.js';
import { renderDashboard } from './pages/dashboard.js';
import { renderEdit } from './pages/edit.js';
import { renderLogin } from './pages/login.js';
import { renderManage } from './pages/manage.js';
import { renderRightsHolderTerms } from './pages/rights-holder-terms.js';
import { renderSettings } from './pages/settings.js';
import { renderUpload } from './pages/upload.js';

// Initialize i18n
initI18n();

// Auth middleware - redirect to login if not authenticated
function requireAuth(handler) {
  return async (params) => {
    if (!isAuthenticated()) {
      window.location.href = '/login';
      return;
    }
    await handler(params);
  };
}

// Configure routes
router.addRoute('/login', async () => {
  await renderLogin();
});

router.addRoute('/callback', async () => {
  await renderCallback();
});

router.addRoute(
  '/',
  requireAuth(async () => {
    await renderDashboard();
  }),
);

router.addRoute(
  '/dashboard',
  requireAuth(async () => {
    await renderDashboard();
  }),
);

router.addRoute('/rights-holder-terms', async () => {
  await renderRightsHolderTerms();
});

router.addRoute(
  '/upload',
  requireAuth(async () => {
    await renderUpload();
  }),
);

router.addRoute(
  '/manage',
  requireAuth(async (params) => {
    await renderManage(params);
  }),
);

router.addRoute(
  '/edit/:id',
  requireAuth(async (params) => {
    await renderEdit(params);
  }),
);

router.addRoute(
  '/settings',
  requireAuth(async () => {
    await renderSettings();
  }),
);

// Initialize application
document.addEventListener('DOMContentLoaded', () => {
  console.log(
    '%c🎬 STROYMA ADMIN',
    'font-size: 24px; font-weight: bold; color: #0077C0;',
  );
  console.log('Content Management for Faroese Originals');

  // Start router
  router.init();
});
